"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTracker = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'AssetTracker';
class AssetTracker extends datamodel_core_1.DeviceEnabledType {
    constructor(ob) {
        var _a, _b, _c, _d, _e;
        super(ob.type || typeName, ob);
        this.batteryPercentage = ob.batteryPercentage || null;
        this.location = ob.location;
        this.lastKnownPosition = (_a = ob.lastKnownPosition) !== null && _a !== void 0 ? _a : null;
        this.batteryVoltage = (_b = ob.batteryVoltage) !== null && _b !== void 0 ? _b : null;
        this.batteryPercentage = (_c = ob.batteryPercentage) !== null && _c !== void 0 ? _c : null;
        this.deviceActive = (_d = ob.deviceActive) !== null && _d !== void 0 ? _d : false;
        this.deviceInactiveSince = (_e = ob.deviceInactiveSince) !== null && _e !== void 0 ? _e : null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
        };
    }
    getLinkAttributes() {
        const functions = this.getUserAttributes().functions;
        return {
            ...super.getLinkAttributes(),
            functions,
        };
    }
}
exports.AssetTracker = AssetTracker;
